import FormComponent from './component/FormComponent';

function App() {
  return <FormComponent />;
}

export default App;
